export default "__VITE_ASSET__CVCd2_lc__"